// Dados dos quartos do Star Hotel.
// Centralizado aqui para ser usado tanto na Home quanto na Galeria,
// evitando manter a mesma informação duplicada em dois arquivos.

export const rooms = [
  {
    id: 'triplo',
    title: 'Quarto Triplo',
    tagline: 'Ideal para famílias e grupos',
    capacity: 'Até 3 hóspedes',
    description:
      'Perfeito para famílias ou grupos de amigos, nosso quarto triplo oferece conforto e espaço para todos. Escolha entre 3 camas de solteiro ou 1 cama de casal e 1 solteiro, garantindo uma estadia agradável para todos os hóspedes.',
    price: 'R$ 405,00',
    priceNote: 'a diária',
    features: [
      '3 camas de solteiro ou 1 de casal e 1 solteiro',
      'Ar condicionado',
      'Televisão',
      'Banheiro privativo',
      'Wi-Fi grátis',
      'Carregador por indução',
      'Café da manhã incluso',
    ],
    images: ['/images/triplo.jpg', '/images/triplo_2.jpg', '/images/triplo_3.jpg'],
  },
  {
    id: 'duplo',
    title: 'Quarto Duplo',
    tagline: 'Conforto e versatilidade',
    capacity: 'Até 2 hóspedes',
    description:
      'Pensado para proporcionar conforto e versatilidade, o quarto duplo dispõe de uma elegante cama de casal, além da opção de configuração com duas camas de solteiro, atendendo com excelência às diferentes preferências de hospedagem.',
    price: 'R$ 300,00',
    priceNote: 'a diária',
    features: [
      'Duas camas de solteiro',
      'Ar condicionado',
      'Televisão',
      'Banheiro privativo',
      'Wi-Fi grátis',
      'Carregador por indução',
      'Café da manhã incluso',
    ],
    images: ['/images/duplo.jpg', '/images/casal.jpg', '/images/duplo_3.jpg', '/images/casal_3.jpg'],
  },
  {
    id: 'casal',
    title: 'Quarto Individual',
    tagline: 'Exclusivo para 1 hóspede',
    capacity: 'Apenas 1 hóspede',
    description:
      'Perfeito para quem busca conforto e privacidade, nosso quarto individual é exclusivo para 1 hóspede e oferece uma cama de casal confortável, ideal para um descanso revigorante e tranquilo.',
    price: 'R$ 220,00',
    priceNote: 'a diária',
    features: [
      'Acomodação para 1 hóspede',
      'Cama de casal',
      'Ar condicionado',
      'Televisão',
      'Banheiro privativo',
      'Wi-Fi grátis',
      'Carregador por indução',
      'Café da manhã incluso',
    ],
    images: ['/images/casal.jpg', '/images/casal_2.jpg', '/images/casal_3.jpg'],
  },
  {
    id: 'flat',
    title: 'Flat',
    tagline: 'Para estadias mais longas',
    description:
      'Viva como em casa com nosso flat exclusivo. Um mini apartamento completo com sala, sofá, cozinha equipada, uma cama de casal e uma de solteiro. Perfeito para estadias mais longas ou quem busca mais conforto e independência.',
    price: 'Sob consulta',
    priceNote: 'aluguel mensal disponível',
    features: [
      'Mini apartamento completo',
      'Sala com sofá',
      'Cozinha equipada',
      'Uma cama de casal e uma de solteiro',
      'Ar condicionado',
      'Televisão',
      'Wi-Fi grátis',
      'Carregador por indução',
    ],
    images: ['/images/flat.jpg', '/images/flat_2.jpg', '/images/flat_3.jpg'],
  },
]
